export default function WhyStudentsLoveIt() {
  const features = [
    {
      icon: "ri-group-line",
      title: "Fully Interactive",
      description: "The students are the stars of the show.",
    },
    {
      icon: "ri-fire-line",
      title: "Clean & High-Energy",
      description: "100% campus-appropriate, hilarious, and jaw-dropping.",
    },
    {
      icon: "ri-layout-line",
      title: "Flexible Setup",
      description: "Works in student centers, lounges, or large theaters.",
    },
    {
      icon: "ri-magic-line",
      title: "Modern Mystery",
      description: "A fresh alternative to traditional comedy nights or hypnotists.",
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-zinc-900 mb-4">
            Why Students Love It
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto"></div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-zinc-900 rounded-2xl p-8 border-2 border-zinc-800 hover:border-red-600 transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i
                  className={`${feature.icon} text-5xl text-red-600 group-hover:scale-110 transition-transform duration-300`}
                ></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-white mb-3">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-zinc-400 leading-relaxed">
                {feature.description}
              </p>

              {/* Hover Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-red-600/0 to-red-600/0 group-hover:from-red-600/5 group-hover:to-red-600/10 rounded-2xl transition-all duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}